import {
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
  Autocomplete
} from "@mui/material";
import { useForm } from "hooks/useForm";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { initialValues, requiredValues } from "./inputValues";
import { useSearch } from "hooks/useSearch";
import { red } from "@mui/material/colors";
import RegularButton from "components/CustomButtons/Button";
import {
  editCarburetion,
  addCarburetion,
} from "redux/actions/carburetions/carburetionAction";
import { getSgc } from "redux/actions/sgc/sgcActions";
import { useCheckInventoryStatus } from "hooks/fetch-hooks/useCheckInventoryStatus";
import { resetOnClick } from "helpers/resetOnClick";
import { useFetchLocal } from "hooks/fetch-hooks/useFetchLocal";
import { api_get, PROYECT } from "services/api";
import { formatCustomDate } from "helpers/dateTools";
import { orderArrayV2 } from "helpers/orderArray";
import { validateObject } from "helpers/validateObject";

const carburationType = [{ label: "GAS_LP", value: "GAS_LP" }];

export const AddCarburetion = ({ data = {}, onClose, isEdit = false }) => {
  const dispatch = useDispatch();
  const { stationsList, stations } = useSelector(({ companies }) => companies);
  const { config } = useSelector(({ login }) => login);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { station } = useSelector(({ carburations }) => carburations);
  const { unitsMap, units: unitsR } = useSelector(
    ({ unitsReducer }) => unitsReducer
  );
  const { sgc } = useSelector(({ sgc }) => sgc);
  const {
    inputValues,
    handleInputOnChange,
    handleNewValues,
    runValidates,
    fieldErrors,
  } = useForm(initialValues, requiredValues);
  const maxDate = new Date();
  maxDate.setDate(new Date().getDate());
  const maxDateString = maxDate.toISOString().split("T")[0];

  const disabledCheckbox =
    validateObject(data) &&
    (data?.fillingOrder?.id !== null || data.chargedVolume !== null);

  const {
    idStation,
    date,
    idUnit,
    initialMileage,
    finalMileage,
    carburation,
    type,
    withOrder,
    sgcID,
  } = inputValues;
  const { errorInv, message: messageInv } = useCheckInventoryStatus(idStation?.id, date);

  const getLastKm = async (unitID, fDate) => {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/carburations/last-kms-by-unit/${unitID}?date=${fDate}`;
    const response = await api_get(url);
    return response;
  };
  const [[lastKmResponse], fetchLastKM] = useFetchLocal(getLastKm);
  const [units, setUnits] = useState([]);
  const [error, setError] = useState({
    isError: false,
    message: "",
  });
  const { isError, message } = error;
  const { setSnackbar } = useSearch();

  const handleStation = (v) => {
    handleNewValues({
      idStation: v,
    });
    v &&
      setUnits(
        unitsMap.filter(
          (unit) =>
            unit.idStation === v?.id &&
            unit.type !== "ESTACION" &&
            unit.type !== "ANDEN"
        )
      );
  };

  const handleUnit = (v) => {
    if (v?.isMaintenance) {
      setSnackbar(`UNIDAD ${v?.number} EN MANTENIMIENTO, CONTACTA A SOPORTE EN CASO DE SER NECESARIO`)
      handleNewValues({
        idUnit: null
      });
      return
    }
    handleNewValues({
      idUnit: v,
    });
    v && fetchLastKM(v?.id, date);
  };

  const handleCarburation = (v) => {
    handleNewValues({
      type: v,
    });
  };

  const handleSGC = (v) => {
    handleNewValues({
      sgcID: v,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (runValidates()) return;
    if (finalMileage < initialMileage || finalMileage === initialMileage)
      return setError({
        isError: true,
        message: "El kilometraje final no puede ser menor o igual al inicial ",
      });
    if (Number(carburation) === 0)
      return setSnackbar("La carburación no puede ir en 0");
    const form = {
      idStation: idStation?.id,
      date,
      idUnit: idUnit?.id,
      initialMileage: Number(initialMileage),
      finalMileage: Number(finalMileage),
      carburation: parseFloat(carburation),
      type: type?.value,
      withOrder,
      status: data?.status || "ACTIVE",
      unit: idUnit?.number,
      printer: config?.printer,
      dispatch: dispatch,
      unitNumber: idUnit?.number,
      sgcID: sgcID?.label || null,
    };
    isEdit
      ? dispatch(editCarburetion(data.id, { ...form, id: data?.id }, onClose))
      : dispatch(addCarburetion(form, onClose));
  };

  useEffect(() => {
    !date && handleNewValues({ date: formatCustomDate(new Date(), "-") });
  }, [date]);

  useEffect(() => {
    sgc.length === 0 && dispatch(getSgc(stationsList));
    const unitsF = unitsMap.filter(
      (unit) => unit.idStation === station?.id || data.id
    );
    setUnits(unitsF);
    if (isEdit) {
      return handleNewValues({
        ...data,
        idStation: stations[data.idStation],
        idUnit: unitsR[data.idUnit],
        sgcID: sgc.find((sgc) => sgc.id === data?.sgc?.id) || null,
        type: carburationType.find((c) => c.value === data.type),
        withOrder: data?.chargedVolume !== null ? false : true,
      });
    } else {
      handleNewValues({ idStation: station });
    }
    carburationType.length === 1 &&
      handleNewValues({ type: carburationType[0] });
  }, []);

  useEffect(() => {
    if (lastKmResponse) {
      handleNewValues({
        initialMileage: lastKmResponse.lastKm,
        finalMileage: lastKmResponse.lastKm,
      });
    }
  }, [lastKmResponse]);

  useEffect(() => {
    if (finalMileage < initialMileage) {
      setError({
        isError: true,
        message: "El kilometraje final no puede ser menor o igual al inicial ",
      }) 
    } else {
      setError({
        isError: false,
        message: "",
      })
    }
  }, [finalMileage]);
  
  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={8} md={8}>
          <Autocomplete
            id="combo-carb-sta"
            options={stationsList}
            value={idStation}
            getOptionLabel={(option) => option.label || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Planta"
                variant="outlined"
                error={fieldErrors.idStation}
                helperText={fieldErrors.idStation || ""}
              />
            )}
            fullWidth
            onChange={(e, v) => handleStation(v)}
            noOptionsText="No se encuentra la planta"
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <TextField
            label="Fecha"
            type="date"
            name="date"
            value={date}
            onChange={handleInputOnChange}
            variant="outlined"
            fullWidth
            error={fieldErrors.date || errorInv}
            helperText={fieldErrors.date || messageInv || ""}
            inputProps={{
              max: maxDateString,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            id="combo-unit-carb"
            options={orderArrayV2(units)}
            value={idUnit}
            getOptionLabel={(option) => option.label || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Unidad"
                variant="outlined"
                error={fieldErrors.idUnit}
                helperText={fieldErrors.idUnit || ""}
              />
            )}
            fullWidth
            onChange={(_, v) => handleUnit(v)}
            noOptionsText="No se encuentra la unidad"
          />
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            id="combo-carb-type"
            options={carburationType}
            value={type}
            getOptionLabel={(option) => option.label || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Tipo de Carburación"
                variant="outlined"
                error={fieldErrors.type}
                helperText={fieldErrors.type || ""}
              />
            )}
            fullWidth
            onChange={(e, v) => handleCarburation(v)}
            noOptionsText="No se encuentra el Carburación"
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <TextField
            type="number"
            label="Kilometraje Inicial"
            name="initialMileage"
            value={initialMileage}
            onChange={handleInputOnChange}
            fullWidth
            variant="outlined"
            inputProps={{ min: 0 }}
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <TextField
            type="number"
            label="Kilometraje Final"
            name="finalMileage"
            value={finalMileage}
            onChange={({ target }) =>
              handleNewValues({ [target.name]: parseInt(target.value) })
            }
            fullWidth
            variant="outlined"
            inputProps={{ min: 0 }}
            error={fieldErrors.finalMileage}
            helperText={fieldErrors.finalMileage || ""}
            onFocus={() =>
              resetOnClick(handleInputOnChange, finalMileage, "finalMileage")
            }
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <TextField
            type="number"
            label="Carburación"
            name="carburation"
            value={carburation}
            onChange={handleInputOnChange}
            fullWidth
            variant="outlined"
            inputProps={{ min: 0 }}
            error={fieldErrors.carburation}
            helperText={fieldErrors.carburation || ""}
            onFocus={() =>
              resetOnClick(handleInputOnChange, carburation, "carburation")
            }
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                name="withOrder"
                color="primary"
                checked={withOrder}
                onChange={() => handleNewValues({ withOrder: !withOrder })}
                disabled={disabledCheckbox}
              />
            }
            label="Con orden de llenado"
            labelPlacement="start"
          />
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            id="combo-box-1243"
            options={sgc}
            value={sgcID}
            getOptionLabel={(option) => option.label || ""}
            renderInput={(params) => (
              <TextField {...params} label="SGC Listado" variant="outlined" />
            )}
            fullWidth
            onChange={(e, v) => handleSGC(v)}
            noOptionsText="No se encuentra la opción"
            disabled={!withOrder || disabledCheckbox}
            required={withOrder ? true : false}
          />
        </Grid>
        {isError ? (
          <Grid item xs={12} sm={6}>
            <Typography variant="body1" style={{ color: red[500] }}>
              {message}
            </Typography>
          </Grid>
        ) : null}
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
          }}
        >
          <RegularButton
            color="danger"
            onClick={onClose}
            disabled={isLoadingComp?.loadingCarburetionActions}
          >
            Cancelar
          </RegularButton>
          <RegularButton
            color="info"
            onClick={handleSubmit}
            disabled={
              isLoadingComp?.loadingCarburetionActions ||
              errorInv ||
              !idUnit ||
              (withOrder && sgcID === null) || isError
            }
            loading={isLoadingComp?.loadingCarburetionActions}
          >
            {isEdit ? "Editar" : "Agregar"}
          </RegularButton>
        </Grid>
      </Grid>
    </form>
  );
};
